import axios from 'axios'
import { clearSession, getRefreshToken, getToken, setTokens } from 'shared/util/storage'

const API_URL = process.env.REACT_APP_API_URL || 'https://api-stag.jordartickets.in/api/'

const instance = axios.create({
  baseURL: API_URL
})

let isRefreshing = false
let pendingQueue = []

function processQueue(error, token = null) {
  pendingQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error)
    else resolve(token)
  })
  pendingQueue = []
}

export function emitSessionExpired() {
  window.dispatchEvent(new CustomEvent('scanner:session-expired'))
}

instance.interceptors.request.use(
  (req) => {
    req.headers['x-sLang'] = req.headers['x-sLang'] || 'en'
    const token = getToken()
    if (token && !req.headers.noAuth) {
      req.headers.authorization = token
      req.headers.Authorization = token
    }
    delete req.headers.noAuth
    return req
  },
  (err) => Promise.reject(err)
)

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {}
    const status = error.response?.status
    const isRefreshCall = String(original.url || '').includes('auth/refresh')

    if (status !== 401 || original._retry || isRefreshCall) {
      if (isRefreshCall && status === 401) {
        clearSession()
        emitSessionExpired()
      }
      return Promise.reject(error)
    }

    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      clearSession()
      emitSessionExpired()
      return Promise.reject(error)
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        pendingQueue.push({ resolve, reject })
      }).then((token) => {
        original.headers = original.headers || {}
        original.headers.authorization = token
        original.headers.Authorization = token
        return instance(original)
      })
    }

    original._retry = true
    isRefreshing = true

    try {
      const { data } = await axios.post(
        `${API_URL}v1/auth/refresh`,
        { sRefreshToken: refreshToken },
        { headers: { 'x-sLang': 'en' } }
      )
      const nextToken = data?.data?.sToken
      const nextRefresh = data?.data?.sRefreshToken
      if (!nextToken) throw new Error('No access token from refresh')
      setTokens(nextToken, nextRefresh)
      processQueue(null, nextToken)
      original.headers = original.headers || {}
      original.headers.authorization = nextToken
      original.headers.Authorization = nextToken
      return instance(original)
    } catch (refreshError) {
      processQueue(refreshError, null)
      clearSession()
      emitSessionExpired()
      return Promise.reject(refreshError)
    } finally {
      isRefreshing = false
    }
  }
)

export default instance
